(() => {
  if (customElements.get('om-dynamic-home')) return;
  class OmDynamicHome extends HTMLElement {
    connectedCallback() {
      if (this.events) return;
      this.events = new AbortController();
      const { signal } = this.events;
      this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.slides = [...this.querySelectorAll('[data-campaign]')];
      const session = this.sessionClock();
      this.index = this.slides.findIndex(slide => !slide.hidden);
      if (this.slides.length) {
        const priority = this.dataset.priorityUntil || '';
        const date = new Date(session.day * 86400000).toISOString().slice(0, 10);
        const index = priority && date < priority ? 0 : session.week % this.slides.length;
        this.activate(index);
        this.querySelector('.omd-hero-nav')?.removeAttribute('hidden');
      }
      this.querySelector('[data-hero-prev]')?.addEventListener('click', () => this.activate(this.index - 1), { signal });
      this.querySelector('[data-hero-next]')?.addEventListener('click', () => this.activate(this.index + 1), { signal });
      this.rotateDaily(session.day);
      this.querySelectorAll('[data-rail-prev], [data-rail-next]').forEach(button => {
        button.addEventListener('click', () => {
          const rail = this.querySelector(`[id="${CSS.escape(button.getAttribute('aria-controls'))}"]`);
          if (!rail) return;
          const item = [...rail.children].find(child => !child.hidden);
          if (!item) return;
          const style = getComputedStyle(rail);
          const distance = item.getBoundingClientRect().width + (parseFloat(style.columnGap) || 0);
          const direction = (button.hasAttribute('data-rail-next') ? 1 : -1) * (style.direction === 'rtl' ? -1 : 1);
          rail.scrollBy({ left: distance * direction, behavior: this.motion.matches ? 'instant' : 'smooth' });
        }, { signal });
      });
      document.addEventListener('shopify:block:select', event => {
        const index = this.slides.findIndex(slide => slide.dataset.campaignId === event.detail?.blockId);
        if (index >= 0) this.activate(index);
      }, { signal });
    }
    sessionClock() {
      const now = Date.now();
      let day = Number(this.dataset.day);
      try {
        const parts = new Intl.DateTimeFormat('en-GB', { timeZone: this.dataset.timeZone || 'Asia/Amman', year: 'numeric', month: '2-digit', day: '2-digit' }).formatToParts(new Date(now));
        const value = type => Number(parts.find(part => part.type === type).value);
        day = Math.floor(Date.UTC(value('year'), value('month') - 1, value('day')) / 86400000);
      } catch (_) {}
      const current = { day, week: Math.floor((day + 3) / 7), seen: now };
      const key = `om-home-visit-v1:${this.dataset.sectionId}`;
      try {
        const stored = JSON.parse(sessionStorage.getItem(key) || 'null');
        if (stored && Number.isInteger(stored.day) && Number.isInteger(stored.week) && now >= stored.seen && now - stored.seen < 1800000) {
          current.day = stored.day;
          current.week = stored.week;
        }
        sessionStorage.setItem(key, JSON.stringify(current));
      } catch (_) {}
      return current;
    }
    rotateDaily(day) {
      const rail = this.querySelector('[data-daily-rail]');
      const source = this.querySelector('[data-daily-order]');
      if (!rail || !source) return;
      try {
        const order = JSON.parse(source.textContent).map(String);
        const byId = new Map([...rail.querySelectorAll('[data-daily-item]')].map(item => [item.dataset.productId, item]));
        const items = order.map(id => byId.get(id)).filter(Boolean);
        if (!items.length) return;
        const stride = items.length % 5 === 0 ? 7 : 5;
        const offset = ((day * stride) % items.length + items.length) % items.length;
        const selected = items.slice(offset).concat(items.slice(0, offset));
        selected.forEach((item, index) => { item.hidden = index >= 6; rail.append(item); });
      } catch (_) {}
    }
    activate(index) {
      if (!this.slides?.length) return;
      this.index = ((index % this.slides.length) + this.slides.length) % this.slides.length;
      this.slides.forEach((slide, position) => {
        slide.hidden = position !== this.index;
        slide.inert = slide.hidden;
        if (!slide.hidden) {
          const image = slide.querySelector('img');
          if (image) image.loading = 'eager';
        }
      });
      const active = this.slides[this.index];
      const nav = this.querySelector('.omd-hero-nav');
      if (nav) nav.style.color = getComputedStyle(active).color;
      const position = this.querySelector('[data-hero-position]');
      if (position) position.textContent = `${String(this.index + 1).padStart(2, '0')} / ${String(this.slides.length).padStart(2, '0')}`;
    }
    disconnectedCallback() {
      this.events?.abort();
      this.events = null;
    }
  }
  customElements.define('om-dynamic-home', OmDynamicHome);
})();
